module.exports = __webpack_public_path__ + "static/media/Finiquitos.0c3d9ec0.svg";